import { render, staticRenderFns } from "./ApproveClueApply.vue?vue&type=template&id=05a5fed6&scoped=true"
import script from "./ApproveClueApply.vue?vue&type=script&lang=js"
export * from "./ApproveClueApply.vue?vue&type=script&lang=js"
import style0 from "./ApproveClueApply.vue?vue&type=style&index=0&id=05a5fed6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5fed6",
  null
  
)

export default component.exports